import { Outlet } from "react-router-dom";
import { AppSidebar } from "@/components/app/AppSidebar";
import { AppHeader } from "@/components/app/AppHeader";
import { WorkspaceProvider } from "@/contexts/WorkspaceContext";
import { ErrorBoundary } from "@/components/app/ErrorBoundary";
import { OnboardingProvider, OnboardingTour } from "@/features/onboarding";
import { ChatProvider, ChatWidget } from "@/features/chat";
import { GeminiStatusBanner } from "@/components/app/GeminiStatusBanner";

export function AppLayout() {
  return (
    <WorkspaceProvider>
      <OnboardingProvider>
        <ChatProvider>
          <div className="flex h-screen bg-background">
            <AppSidebar />
            <div className="flex-1 flex flex-col min-w-0">
              <AppHeader />
              <GeminiStatusBanner />
              <main className="flex-1 overflow-y-auto p-6">
                <ErrorBoundary>
                  <Outlet />
                </ErrorBoundary>
              </main>
            </div>
          </div>
          <OnboardingTour />
          <ChatWidget />
        </ChatProvider>
      </OnboardingProvider>
    </WorkspaceProvider>
  );
}
